import React from 'react';
import { WorkspaceModeLayout } from './WorkspaceModeLayout';
import type { WorkspaceMode } from '@auw/workspace-utils';

interface WorkspaceModeFrameProps {
  mode: WorkspaceMode;
  children: React.ReactNode;
  inputSlot?: React.ReactNode;
  aboveInputSlot?: React.ReactNode;
}

export const WorkspaceModeFrame: React.FC<WorkspaceModeFrameProps> = (props) => {
  return <WorkspaceModeLayout {...props} />;
};
